import React, { useEffect, useState } from 'react';
import { Table, Space, Spin } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import qs from 'query-string';
import { useTableInfo } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';


interface FormItemProps {
  historyList: any[] | undefined;  
  searchResult: any;  
  onSearch : (data: any) => void;
}

const LecturerHistoryTable = ({historyList, searchResult, onSearch}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  const columns: ColumnsType<any> = [
    {
      title: '강의날짜',
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      width: '100px',
      align: 'center',    
      ellipsis: true,
    },      
    {
      title: '기업명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'center',
      ellipsis: true,
    },   
    {
      title: '프로젝트명',
      dataIndex: 'title',
      key: 'title',
      width: 'auto',
      align: 'center', 
      ellipsis: true,   
    },
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '130px',
      align: 'center',
      ellipsis: true,
    },        
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: 'auto',
      align: 'center',
      ellipsis: true,
    },      
    {
      title: '강의시간',
      dataIndex: 'time_count',
      key: 'time_count',
      width: '80px',
      align: 'center',
      ellipsis: true,
    }, 
    {
      title: '5점',
      dataIndex: 'class5',
      key: 'class5',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
        )
      }     
    },  
    {
      title: '7점',
      dataIndex: 'class7',
      key: 'class7',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
        )
      }      
    },  
    {
      title: '10점',
      dataIndex: 'class10',
      key: 'class10',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
        )
      }      
    },  
    {
      title: 'NPS',
      dataIndex: 'nps',
      key: 'nps',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
        )
      }      
    },   
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onChangePageInfo = (pageNo: number, pageSize: number) => {
    onSearch({ pageNo, pageSize })
  };  

  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchResult.pageNo) || 1,
      pageSize: Number(searchResult.pageSize) || INIT_PAGESIZE,
    },
    datas: historyList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
  });

  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <TotalNumMenu totalNum={searchResult.totalCount}/>
      <TableWrapper isSearch={true}>
        <Table
          tableLayout="fixed"
          dataSource={historyList}
          columns={columns}
          pagination={pagination}
          onChange={onTableChange}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          rowKey={'id'}
        />
      </TableWrapper>  
  </Space>    
  );
};

export default LecturerHistoryTable;
